import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, Button, TextField } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import BackButton from "components/shared/BackButton";
import { StyledStack, StyledTitle, ButtonContainer } from "./Add.style";
import DrawerCM from "components/shared/Drawer";
import Toast from "helper/toast";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import { addQuestionRequest } from "api/requests";
import { commonQuestionSchema } from "validations";

export default function AddQuestion() {
  const navigate = useNavigate();
  const { request, loading } = useHttp(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(commonQuestionSchema),
  });

  const onSubmit = async (values) => {
    const res = await request({
      url: addQuestionRequest,
      values,
    });

    if (res) Toast({ type: "success", title: "ثبت سوال" });
    navigate("/question")
  };

  return (
    <DrawerCM title="ثبت سوال">
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={2}>
          <Grid item mt={3} xs={12}>
            <BackButton />
          </Grid>
          <StyledStack>
            <StyledTitle>ثبت سوال جدید</StyledTitle>
            <Grid container>
              <Grid item xs={12} p={1.2}>
                <TextField
                  id="question"
                  {...register("question")}
                  label="پرسش"
                  variant="outlined"
                  multiline
                  rows={2}
                  fullWidth
                  error={Boolean(errors.question)}
                  helpertext={errors.question?.message}
                />
              </Grid>
              <Grid item xs={12} p={1.2}>
                <TextField
                  id="answer"
                  {...register("answer")}
                  label="پاسخ"
                  variant="outlined"
                  multiline
                  rows={2}
                  fullWidth
                  error={Boolean(errors.answer)}
                  helpertext={errors.answer?.message}
                />
              </Grid>

              <ButtonContainer>
                <Button
                  startIcon={<CheckIcon />}
                  variant="contained"
                  sx={{ mt: 1 }}
                  onClick={handleSubmit(onSubmit)}
                >
                  ذخیره
                </Button>
              </ButtonContainer>
            </Grid>
          </StyledStack>
        </Grid>
      )}
    </DrawerCM>
  );
}
